import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b27416ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Node = _resolveComponent("Node")!

  return (_ctx.unref(_ctx.visibility) !== _ctx.Visibility.None)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        class: _normalizeClass({ feature: true, tile: true, can: _ctx.unref(_ctx.canClick), locked: !_ctx.unref(_ctx.canClick) }),
        style: _normalizeStyle([
            {
                visibility: _ctx.unref(_ctx.visibility) === _ctx.Visibility.Hidden ? 'hidden' : undefined
            },
            _ctx.unref(_ctx.style) ?? {}
        ]),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
        onMousedown: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args))),
        onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args))),
        onMouseup: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args))),
        onTouchstartPassive: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.start && _ctx.start(...args))),
        onTouchendPassive: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args))),
        onTouchcancelPassive: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.stop && _ctx.stop(...args)))
      }, [
        (_ctx.title)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.titleComponent)))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.component), { style: {"white-space":"pre-line"} })),
        _createVNode(_component_Node, { id: _ctx.id }, null, 8, ["id"])
      ], 38))
    : _createCommentVNode("", true)
}